<template>
    <div id="course-details">
        <a-page-header :title="courseInfo.name">
            <template slot="footer">
                <a-tabs @change="tabsChange" v-model="tabActive">
                    <a-tab-pane :key="item.fullPath" :tab="item.meta.title" v-for="item in routes"/>
                </a-tabs>
            </template>

            <a-descriptions>
                <a-descriptions-item label="所属机构">
                    {{ courseInfo.organizationName }}
                </a-descriptions-item>
                <a-descriptions-item label="课程资源">
                    {{
                        courseInfo.courseResourceName ? courseInfo.courseResourceName + (courseInfo.period ? ' - ' + courseInfo.period : '') : ''
                    }}
                </a-descriptions-item>
                <a-descriptions-item label="课程码类型">
                    <span v-if="courseInfo.codeType === 1">班级码</span>
                    <span v-else-if="courseInfo.codeType === 2">学生码</span>
                    <span v-else>无课程码</span>
                </a-descriptions-item>
                <a-descriptions-item label="课程类型">
                    {{ types[courseInfo.courseType] }}
                </a-descriptions-item>
                <a-descriptions-item label="生效时间">
                    {{ courseInfo.effectiveDate && courseInfo.effectiveDate.split(' ')[0] }}
                    ~
                    {{ courseInfo.uneffectiveDate && courseInfo.uneffectiveDate.split(' ')[0] }}
                </a-descriptions-item>
                <a-descriptions-item label="创建时间">
                    {{ courseInfo.createTime && courseInfo.createTime.split(' ')[0] }}
                </a-descriptions-item>
                <a-descriptions-item label="备注" span="2">
                    {{ courseInfo.description }}
                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "courseDetails",
    data() {
        return {
            types: ["", "测评课程", "训练课程", "活动课程"],
            courseInfo: this.$store.getters["organization/getCourseInfo"](),
            routes: [],
            tabActive: this.$route.path
        }
    },
    watch: {
        $route(to, from) {
            this.$store.commit('account/set_breadcrumb', this.$store.state.account.breadcrumb.filter(f => f.name !== '课程详情'));
        }
    },
    mounted() {
      const tree = (arr) => {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].fullPath === "/projectImpl/CourseManage/details") {
                    this.routes = arr[i].children
                    return
                }
                if (arr[i].children && arr[i].children.length) {
                    tree(arr[i].children);
                }
            }
        }
        tree(this.$router.options.routes);
        this.$store.commit('account/set_breadcrumb', this.$store.state.account.breadcrumb.filter(f => f.name !== '课程详情'));
    },
    methods: {
        tabsChange(val) {
            this.$router.push({
                path: val,
                query: this.$route.query
            })
        }
    }
}
</script>

<style scoped lang="less">
#course-details {
    background-color: #fff;
    margin: -110px -24px 0;
}
</style>
